<script lang="ts" setup>
import BaseLabel from '@/atoms/BaseLabel.vue';
</script>
<template>
  <div>
    <BaseLabel
      color="primary"
      preset="medium"
      text="Avant de commencer l'entretien avec le participant, interrogez le sur ses antécédents liés au stress.

Vous pouvez notamment poser les questions suivantes:
- Avez-vous déjà consulté un professionnel de santé pour des questions liées à votre stress ?
- Êtes-vous traité pour de la dépression ?
- Êtes-vous traité pour des problèmes d'insomnie ?
- Avez-vous une maladie cardiovasculaire ?
- Avez-vous une maladie gastro-intestinale ?

Vous pouvez également demander si le participant a des traitements pour ces pathologies."
      weight="regular"
    ></BaseLabel>
  </div>
</template>
